import $ from '@vaersaagod/tools/Dom';
import Flickity from 'flickity';

export default el => {
    const $el = $(el);
    let flkty;

    const init = () => {
        flkty = new Flickity($el.find('[data-slider]').get(0), {
            cellSelector: '[data-slide]',
            wrapAround: true,
            contain: true,
            pageDots: false,
            prevNextButtons: true,
            draggable: true,
            dragThreshold: 10,
            cellAlign: 'center',
            setGallerySize: false,
            percentPosition: true,
            accessibility: true,
            arrowShape: 'M47.6 31.4l-19 19 19 18.9 2.8-3-13.9-13.8h35.9v-4.3H36.5l13.9-13.8z'
        });
    };

    const destroy = () => {
        flkty.destroy();
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Slideshow.js